'use client';
import clsx from 'clsx';
import { When } from 'react-if';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import PriceView from '@/components/shared/components/price-view';
import useAddToCartHandler from '@/components/shared/helpers/hooks/use-add-to-cart-handler';

import SmartOfferModel from '@/models/smart-offer.model';

export default function SmartInLineCart({ data }: { data: SmartOfferModel }) {
  const { handleAddToCart, isAddingToCart } = useAddToCartHandler();

  const handleAddToCartClick = () => {
    handleAddToCart({ data });
  };
  return (
    <Container
      className={cn(
        'mt-1 flex w-full flex-col justify-between rounded-xl bg-[#FFF5E6] pt-3 pr-2 pb-3 pl-2 md:h-[87px] md:flex-row md:items-center md:pr-3 md:pl-4',
      )}
    >
      <Container className='flex items-center justify-start gap-2 md:justify-start'>
        <XImage
          width={50}
          height={50}
          src={data?.product?.icon?.publicLink}
          alt={data?.title}
          className='h-[50px] rounded-[10px] object-cover object-center'
        />

        <Container>
          <Text className='line-clamp-1 text-lg text-xl font-bold text-[#424244] md:text-start'>
            {data?.title}
          </Text>
          <Text className='line-clamp-2 text-[13px] text-[#76767C] md:text-start'>
            {data?.description}
          </Text>
        </Container>
      </Container>
      <Container
        className={clsx(
          data?.product?.price ? 'justify-between' : 'justify-end',
          'relative mr-3 mr-8! ml-3 flex flex-row items-center gap-2 md:mx-0 md:gap-1',
        )}
      >
        <When condition={data?.product?.price}>
          <Container className='relative mr-9 md:mr-0'>
            <PriceView
              discountLabelClassName=' text-[13px]! absolute -right-10  top-[15%] mx-auto border-[#FFFFFF] border-[2px] w-9 h-9 shadow-[0px_4px_12px_-5px_#FF7B016E]'
              showDiscountLabel={true}
              key={data?.id}
              price={data?.product?.price}
              lastPrice={data?.product?.lastPrice}
              discount={data?.product?.discount}
            />
          </Container>
        </When>
        <Button
          className='mt-2 h-10 w-[110px] bg-[#FFB616]! text-[15px] whitespace-nowrap transition-colors! duration-500 hover:border-1 hover:border-[#F89406] hover:bg-[#FFF]! hover:text-[#F89406] md:mt-0'
          onClick={handleAddToCartClick}
          isLoading={isAddingToCart}
        >
          {data?.buttonText}
        </Button>
      </Container>
    </Container>
  );
}
